export const formatDate = (date) => {
  if (date === undefined || date === null || date === "") {
    return "No date available";
  }

  const parsed = new Date(date);
  if (Number.isNaN(parsed.getTime())) return "No date available";

  const day = String(parsed.getDate()).padStart(2, "0");
  const month = String(parsed.getMonth() + 1).padStart(2, "0");
  const year = parsed.getFullYear();
  return `${day}-${month}-${year}`;
};

export const formatDescription = (description, dispatchNote) => {
  return description + (dispatchNote ? `, ${dispatchNote}` : "");
};
